var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotesOpen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0002 1V2.6M8.0002 1V2.6M4.0002 1V2.6M4.8002 11.4H8.0002M4.8002 7.4H11.2002M1.2002 12.2V6.6C1.2002 4.3376 1.2002 3.2056 1.9034 2.5032C2.6058 1.8 3.7378 1.8 6.0002 1.8H10.0002C12.2626 1.8 13.3946 1.8 14.097 2.5032C14.8002 3.2056 14.8002 4.3376 14.8002 6.6V9C14.8002 12.7712 14.8002 14.6568 13.6282 15.828C12.4578 17 10.5722 17 6.8002 17H6.0002C3.7378 17 2.6058 17 1.9034 16.2968C1.2002 15.5944 1.2002 14.4624 1.2002 12.2Z",
    stroke: "#04245C",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7998 10.9995C14.7998 11.2622 14.7481 11.5222 14.6476 11.7649C14.5471 12.0075 14.3997 12.228 14.214 12.4137C14.0283 12.5994 13.8078 12.7468 13.5652 12.8473C13.3225 12.9478 13.0624 12.9995 12.7998 12.9995C12.3998 12.9995 11.9294 12.9299 11.5414 13.0339C11.3718 13.0793 11.2172 13.1686 11.093 13.2928C10.9689 13.4169 10.8796 13.5715 10.8342 13.7411C10.7302 14.1291 10.7998 14.6003 10.7998 14.9995C10.7998 15.5299 10.5891 16.0387 10.214 16.4137C9.83895 16.7888 9.33024 16.9995 8.7998 16.9995",
    stroke: "#2173FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotesOpen);
export default __webpack_public_path__ + "static/media/notes_open.4c6fd9262460d051d648a061286c0bf4.svg";
export { ForwardRef as ReactComponent };